<mat-form-field class="chip-list" appearance="fill">
  <mat-label>{{label}}</mat-label>
  <mat-chip-list #chipList aria-label="Selection"
                 [required]="required">
    <mat-chip
      *ngFor="let item of selectedItems"
      [selectable]="selectable"
      [removable]="isRemovable(item)"
      (removed)="remove(item)">
      {{item?.name}}
      <mat-icon matChipRemove *ngIf="isRemovable(item)">cancel</mat-icon>
    </mat-chip>
    <input
      placeholder="{{placeholder}}"
      #input
      [formControl]="formCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
      [readOnly]="readonly">
  </mat-chip-list>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let item of allItems$" [value]="item">
      {{item?.name}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
